import React, {Component} from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import Heroimage from '../../components/Heroimage'
import VettrisHeader from '../../components/VettrisHeader'
import contentfulData from '../../../contentfuldata/data.json';
import Radium from 'radium';
import {StyleRoot} from 'radium';
import VettrisFooter from '../../components/VettrisFooter';
import ClinicsDetailPage from '../../components/ClinicsDetailPage'
import Breadcrumbs from '../../components/Breadcrumbs';
import Breakpoints from '../../utils/breakpoints';
import _ from 'lodash'
import {prettifyUrl, getLang, eventDispatch} from "../../utils/util-functions";
export class IndexPage extends Component {

  constructor(props, context) {
    super(props, context);
    this.changeUrl = this.changeUrl.bind(this);
    this.changeUrlArticle = this.changeUrlArticle.bind(this);
    this.onPopstate = this.onPopstate.bind(this);

    this.state = {
      searchString: "",
      rendered: false //to prevent google maps loading twice
    }
  }

  changeUrl (clinic){
    this.props.history.push('/'+this.state.path+'/'+clinic);
    this.setState({
      searchString: {clinic: clinic}
    });
    eventDispatch('hashchange');
  }

  onPopstate(){
    this.setState({
      searchString: window.location.hash ? {clinic: window.location.hash.split("clinic=")[1]} : ""
    });
  }

  changeUrlArticle (article){
    this.props.history.push('/guides/#article='+article);
  }

  componentDidMount() {
    window.addEventListener("popstate", this.onPopstate);
    window.addEventListener('hashchange', this.onPopstate);

    this.setState({
      path: location ? location.pathname.split('/').filter((strPiece) => strPiece.length>1) : "",
      searchString: this.props.pathContext,
      rendered: true
    });

    //! Crude redirect to ensure correct navigation if user ends up on page from organic search
    //! Should be replaced with proper redirects in hosting provider AWS
    if (this.props.pathContext.clinic) {
      const clinic = _.find(contentfulData.clinicsData[getLang()].clinicsData, clinic => prettifyUrl(clinic.name)===prettifyUrl(this.props.pathContext.clinic));
      if (clinic.externalUrl) {
        window.location = clinic.externalUrl
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onPopstate);
    window.removeEventListener('hashchange', this.onHashChange);
  }

  getHeroImage(brand){
    const clinics = contentfulData.clinicsData[brand].clinicsData;
    if (this.state.searchString.clinic){
      let heroImage = _.find(clinics, clinic => prettifyUrl(clinic.name)===prettifyUrl(this.state.searchString.clinic));

      if (!heroImage.localHeroPhoto)
        return contentfulData.singleData[brand].singleData.frontpageHeroImage.fields.file ? contentfulData.singleData[brand].singleData.frontpageHeroImage.fields.file.url : "";
      else
        return heroImage.localHeroPhoto ? heroImage.localHeroPhoto.fields.file.url : "";
    } else {
      return contentfulData.singleData[brand].singleData.frontpageHeroImage.fields.file ? contentfulData.singleData[brand].singleData.frontpageHeroImage.fields.file.url : "";
    }
  }

  getHeroText(brand){
    const clinics = contentfulData.clinicsData[brand].clinicsData;
    if (this.state.searchString.clinic) {
      let heroText = _.find(clinics, clinic => prettifyUrl(clinic.name) === prettifyUrl(this.state.searchString.clinic));
      return heroText.localHeroNames || "";
    }
    return "";
  }

  render() {
    const brand = getLang();
    const heroText = contentfulData.singleData[brand].singleData.frontpageHeroText;
    const heroImage = this.getHeroImage(brand);
    const heroParagraph = this.getHeroText(brand);
    const clinics = contentfulData.clinicsData[brand].clinicsData;
    const heroImageColor = "#ffffff";
    return (
        <div>
          <StyleRoot>
            <VettrisHeader history={this.props.history}/>
            <Heroimage url={heroImage} heroText={heroText} color={heroImageColor} heroParagraph={heroParagraph}/>
            <div style={styles}>
              <div className="col-xs-12">
                <Breadcrumbs />
              </div>
              <div className="clearfix"></div>
            </div>
            {this.props.pathContext.clinic &&
              <ClinicsDetailPage history={this.props.history} activeClinic={this.props.pathContext.clinic} clinics={clinics} />
            }
            <VettrisFooter/>
          </StyleRoot>
        </div>
    )
  }
}

export default Radium(IndexPage)

const styles = {
  width: '100%',
  margin: '0 auto',
  [Breakpoints.media.siteOverMaxWidth]: {
    width: Breakpoints.width.site
  }
};


// WEBPACK FOOTER //
// ./src/pages/clinicdetail/index.js